import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const FAQ: BuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  information: {
    single: 'Faq',
    plural: 'Faqs',
    ribonIcon: require('../../../../img/buildingBlocks/FAQ.svg'),
  },

  buildingBlocks: [
    { type: NodeType.PARAGRAPH },
    { type: NodeType.IMAGE_GROUP },
    { type: NodeType.IMAGE },
    { type: NodeType.VIDEO },
    { type: NodeType.ATTACHMENTS_GROUP },
    { type: NodeType.QUOTE },
  ],
  edit: [
    {
      ...titleComponent,
      label: 'Vraag',
    },
  ],
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default FAQ;
